<div class="content-container">
  <div class="content-centered">
    <h1 class="custom-h1" translate>REPORT.MISSING_ORGANIZATION.HEADING</h1>
    <div class="visual-container">
      <p class="missing-organization-hint" [innerHTML]="'REPORT.MISSING_ORGANIZATION.HINT' | translate"></p>
    </div>
  </div>
</div>